/* @ngInject */

export default ($q, fieldsService, workflowService, IMPORT) => {
  /**
   * Get field name depending of the desired index.
   *
   * @param {String} name
   * @param {Number} index
   *
   * @returns {String}
   */
  const getFieldName = ({ name, index }) => {
    if (name && index > -1) {
      const n = name.split(' - ');
      return n[index] !== '' ? n[index] : n[index - 1];
    }
    return null;
  };

  /**
   * Get field full name.
   *
   * @param {String} name
   *
   * @returns {String}
   */
  const getFieldFullName = ({ name }) => {
    if (name) {
      const n = name.split(' - ');
      return `${n[0]} - ${n[1]}`;
    }
    return '-';
  };

  /**
   * Get grouped import fields.
   *
   * @returns {Array}
   */
  const getFields = (isTicket, isPerson, isCompany, isNote, isJob, isAccount) => {
    const fields = [];

    return $q
      .all([fieldsService.getAvailable({ entity: 'ticket', isActive: true })])
      .then(function (results) {
        if (isTicket) {
          const ticketsFields = IMPORT.MERGE_FIELDS.TICKET || [];
          const tLen = ticketsFields.length;
          for (let t = 0; t < tLen; t += 1) {
            const ticketsField = ticketsFields[t];
            if (getFieldName({ name: ticketsField.name, index: 1 }) === 'Basic information') {
              if (_.findIndex(fields, { name: 'Deal - Basic information' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a01',
                  icon: 'monetization_on',
                  isOpen: true,
                  workflowType: null,
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Basic information' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Asset finance'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Asset finance' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a02',
                  icon: 'account_circle',
                  isOpen: false,
                  workflowType: 'assetfinance',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Asset finance' });
                fields[idx].value.push(ticketsField);
              }
            } else if (getFieldName({ name: ticketsField.name, index: 1 }) === 'Insurance') {
              if (_.findIndex(fields, { name: 'Deal - Insurance' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a03',
                  icon: 'home',
                  isOpen: false,
                  workflowType: 'insurance',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Insurance' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Home loan security'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Home loan security' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a04',
                  icon: 'security',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Home loan security' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Home loan split'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Home loan split' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a05',
                  icon: 'account_balance',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Home loan split' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Home loan fees'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Home loan fees' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a06',
                  icon: 'monetization_on',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Home loan fees' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Income contact 1'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Income contact 1' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a09',
                  icon: 'payment',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Income contact 1' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Income contact 2'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Income contact 2' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a10',
                  icon: 'payment',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Income contact 2' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Income contact 3'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Income contact 3' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a11',
                  icon: 'payment',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Income contact 3' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Income contact 4'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Income contact 4' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a12',
                  icon: 'payment',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Income contact 4' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Income contact 5'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Income contact 5' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a13',
                  icon: 'payment',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Income contact 5' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Income contact 6'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Income contact 6' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a14',
                  icon: 'payment',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Income contact 6' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Expenses household 1'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Expenses household 1' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a15',
                  icon: 'shopping_cart',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Expenses household 1' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Expenses household 2'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Expenses household 2' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a16',
                  icon: 'shopping_cart',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Expenses household 2' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Expenses household 3'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Expenses household 3' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a17',
                  icon: 'shopping_cart',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Expenses household 3' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Expenses household 4'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Expenses household 4' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a18',
                  icon: 'shopping_cart',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Expenses household 4' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Expenses household 5'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Expenses household 5' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a19',
                  icon: 'shopping_cart',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Expenses household 5' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets owner occupier 1'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets owner occupier 1' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a20',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets owner occupier 1' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets owner occupier 2'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets owner occupier 2' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a21',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets owner occupier 2' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets owner occupier 3'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets owner occupier 3' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a22',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets owner occupier 3' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets owner occupier 4'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets owner occupier 4' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a23',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets owner occupier 4' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets owner occupier 5'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets owner occupier 5' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a24',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets owner occupier 5' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets owner occupier 6'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets owner occupier 6' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a25',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets owner occupier 6' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets investment 1'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets investment 1' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a26',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets investment 1' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets investment 2'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets investment 2' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a27',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets investment 2' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets investment 3'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets investment 3' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a28',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets investment 3' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets investment 4'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets investment 4' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a29',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets investment 4' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets investment 5'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets investment 5' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a30',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets investment 5' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets investment 6'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets investment 6' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a31',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets investment 6' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets vehicle 1'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets vehicle 1' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a32',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets vehicle 1' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets vehicle 2'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets vehicle 2' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a33',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets vehicle 2' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets vehicle 3'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets vehicle 3' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a34',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets vehicle 3' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets bank accounts 1'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets bank accounts 1' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a35',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets bank accounts 1' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets bank accounts 2'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets bank accounts 2' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a36',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets bank accounts 2' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets bank accounts 3'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets bank accounts 3' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a37',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets bank accounts 3' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets home contents 1'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets home contents 1' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a38',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets home contents 1' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets home contents 2'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets home contents 2' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a39',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets home contents 2' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets home contents 3'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets home contents 3' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a40',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets home contents 3' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Assets superfund institution 1'
            ) {
              if (
                _.findIndex(fields, { name: 'Deal - Assets superfund institution 1' }) === -1
              ) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a41',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, {
                  name: 'Deal - Assets superfund institution 1'
                });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Assets superfund institution 2'
            ) {
              if (
                _.findIndex(fields, { name: 'Deal - Assets superfund institution 2' }) === -1
              ) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a41',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, {
                  name: 'Deal - Assets superfund institution 2'
                });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Assets superfund institution 3'
            ) {
              if (
                _.findIndex(fields, { name: 'Deal - Assets superfund institution 3' }) === -1
              ) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a42',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, {
                  name: 'Deal - Assets superfund institution 3'
                });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets shares 1'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets shares 1' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a43',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets shares 1' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets shares 2'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets shares 2' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a44',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets shares 2' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets shares 3'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets shares 3' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a45',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets shares 3' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Assets other 1'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Assets other 1' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a46',
                  icon: 'add_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Assets other 1' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Liabilities mortgage loan 1'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities mortgage loan 1' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a47',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, {
                  name: 'Deal - Liabilities mortgage loan 1'
                });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Liabilities mortgage loan 2'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities mortgage loan 2' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a48',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, {
                  name: 'Deal - Liabilities mortgage loan 2'
                });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Liabilities mortgage loan 3'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities mortgage loan 3' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a49',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, {
                  name: 'Deal - Liabilities mortgage loan 3'
                });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Liabilities mortgage loan 4'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities mortgage loan 4' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a50',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, {
                  name: 'Deal - Liabilities mortgage loan 4'
                });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Liabilities mortgage loan 5'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities mortgage loan 5' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a51',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, {
                  name: 'Deal - Liabilities mortgage loan 5'
                });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Liabilities mortgage loan 6'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities mortgage loan 6' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a52',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, {
                  name: 'Deal - Liabilities mortgage loan 6'
                });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Liabilities credit card 1'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities credit card 1' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a53',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Liabilities credit card 1' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Liabilities credit card 2'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities credit card 2' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a54',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Liabilities credit card 2' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Liabilities credit card 3'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities credit card 3' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a55',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Liabilities credit card 3' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Liabilities vehicle loan 1'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities vehicle loan 1' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a56',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, {
                  name: 'Deal - Liabilities vehicle loan 1'
                });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Liabilities vehicle loan 2'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities vehicle loan 2' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a57',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, {
                  name: 'Deal - Liabilities vehicle loan 2'
                });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Liabilities vehicle loan 3'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities vehicle loan 3' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a58',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, {
                  name: 'Deal - Liabilities vehicle loan 3'
                });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Liabilities personal loan 1'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities personal loan 1' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a59',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, {
                  name: 'Deal - Liabilities personal loan 1'
                });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Liabilities personal loan 2'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities personal loan 2' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a60',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, {
                  name: 'Deal - Liabilities personal loan 2'
                });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Liabilities personal loan 3'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities personal loan 3' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a61',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, {
                  name: 'Deal - Liabilities personal loan 3'
                });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Liabilities SMSF loan 1'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities SMSF loan 1' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a62',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Liabilities SMSF loan 1' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Liabilities SMSF loan 2'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities SMSF loan 2' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a63',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Liabilities SMSF loan 2' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Liabilities SMSF loan 3'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities SMSF loan 3' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a64',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Liabilities SMSF loan 3' });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Liabilities education debt 1'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities education debt 1' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a65',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, {
                  name: 'Deal - Liabilities education debt 1'
                });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Liabilities education debt 2'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities education debt 2' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a66',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, {
                  name: 'Deal - Liabilities education debt 2'
                });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) ===
              'Liabilities education debt 3'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities education debt 3' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a67',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, {
                  name: 'Deal - Liabilities education debt 3'
                });
                fields[idx].value.push(ticketsField);
              }
            } else if (
              getFieldName({ name: ticketsField.name, index: 1 }) === 'Liabilities other 1'
            ) {
              if (_.findIndex(fields, { name: 'Deal - Liabilities other 1' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: ticketsField.name }),
                  level: 0,
                  weight: 'a68',
                  icon: 'remove_circle',
                  isOpen: false,
                  workflowType: 'homeloan',
                  value: [ticketsField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Deal - Liabilities other 1' });
                fields[idx].value.push(ticketsField);
              }
            }
          }

          if (results[0].length) {
            const cf = [];
            const cfLen = results[0].length;
            let count = 1;
            for (let c = 0; c < cfLen; c += 1) {
              const customField = results[0][c];
              let customFieldType = 'string';
              if (customField.type === 'number') {
                customFieldType = 'number';
              }
              if (customField.type === 'money') {
                customFieldType = 'money';
              }
              if (customField.type === 'phone') {
                customFieldType = 'phone';
              }
              cf.push({
                name: `Deal - Custom fields - ${customField.name}`,
                key: `customField${customField.name
                  .capitalizeFirstLetter()
                  .replace(/\W/g, '')}${count}`,
                type: customFieldType,
                required: false,
                weight: count
              });
              count += 1;
            }
            fields.push({
              name: 'Deal - Custom fields',
              level: 0,
              weight: 'a64',
              icon: 'input',
              isOpen: false,
              value: cf
            });
          }
        }

        if (isPerson) {
          const personFields = IMPORT.MERGE_FIELDS.CONTACT_PERSON || [];
          const pLen = personFields.length;
          for (let p = 0; p < pLen; p += 1) {
            const personField = personFields[p];
            if (getFieldName({ name: personField.name, index: 0 }) === 'Person 1') {
              if (getFieldName({ name: personField.name, index: 1 }) === 'Personal details') {
                if (_.findIndex(fields, { name: 'Person 1 - Personal details' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c01',
                    icon: 'account_circle',
                    isOpen: true,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 1 - Personal details' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) === 'Contact details'
              ) {
                if (_.findIndex(fields, { name: 'Person 1 - Contact details' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c02',
                    icon: 'phone',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 1 - Contact details' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) === 'Identification'
              ) {
                if (_.findIndex(fields, { name: 'Person 1 - Identification' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c03',
                    icon: 'perm_contact_calendar',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 1 - Identification' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) === 'Family relations'
              ) {
                if (_.findIndex(fields, { name: 'Person 1 - Family relations' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c04',
                    icon: 'wc',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 1 - Family relations' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) ===
                'Employments details (current employer)'
              ) {
                if (
                  _.findIndex(fields, {
                    name: 'Person 1 - Employments details (current employer)'
                  }) === -1
                ) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c05',
                    icon: 'work',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, {
                    name: 'Person 1 - Employments details (current employer)'
                  });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) ===
                'Employments details (previous employer)'
              ) {
                if (
                  _.findIndex(fields, {
                    name: 'Person 1 - Employments details (previous employer)'
                  }) === -1
                ) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c06',
                    icon: 'work',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, {
                    name: 'Person 1 - Employments details (previous employer)'
                  });
                  fields[idx].value.push(personField);
                }
              } else if (getFieldName({ name: personField.name, index: 1 }) === 'Notes') {
                if (_.findIndex(fields, { name: 'Person 1 - Notes' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c08',
                    icon: 'subject',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 1 - Notes' });
                  fields[idx].value.push(personField);
                }
              }
            } else if (getFieldName({ name: personField.name, index: 0 }) === 'Person 2') {
              if (getFieldName({ name: personField.name, index: 1 }) === 'Personal details') {
                if (_.findIndex(fields, { name: 'Person 2 - Personal details' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c09',
                    icon: 'account_circle',
                    isOpen: true,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 2 - Personal details' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) === 'Contact details'
              ) {
                if (_.findIndex(fields, { name: 'Person 2 - Contact details' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c10',
                    icon: 'phone',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 2 - Contact details' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) === 'Identification'
              ) {
                if (_.findIndex(fields, { name: 'Person 2 - Identification' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c11',
                    icon: 'perm_contact_calendar',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 2 - Identification' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) === 'Family relations'
              ) {
                if (_.findIndex(fields, { name: 'Person 2 - Family relations' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c12',
                    icon: 'wc',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 2 - Family relations' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) ===
                'Employments details (current employer)'
              ) {
                if (
                  _.findIndex(fields, {
                    name: 'Person 2 - Employments details (current employer)'
                  }) === -1
                ) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c13',
                    icon: 'work',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, {
                    name: 'Person 2 - Employments details (current employer)'
                  });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) ===
                'Employments details (previous employer)'
              ) {
                if (
                  _.findIndex(fields, {
                    name: 'Person 2 - Employments details (previous employer)'
                  }) === -1
                ) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c14',
                    icon: 'work',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, {
                    name: 'Person 2 - Employments details (previous employer)'
                  });
                  fields[idx].value.push(personField);
                }
              } else if (getFieldName({ name: personField.name, index: 1 }) === 'Notes') {
                if (_.findIndex(fields, { name: 'Person 2 - Notes' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c15',
                    icon: 'subject',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 2 - Notes' });
                  fields[idx].value.push(personField);
                }
              }
            } else if (getFieldName({ name: personField.name, index: 0 }) === 'Person 3') {
              if (getFieldName({ name: personField.name, index: 1 }) === 'Personal details') {
                if (_.findIndex(fields, { name: 'Person 3 - Personal details' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c16',
                    icon: 'account_circle',
                    isOpen: true,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 3 - Personal details' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) === 'Contact details'
              ) {
                if (_.findIndex(fields, { name: 'Person 3 - Contact details' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c17',
                    icon: 'phone',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 3 - Contact details' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) === 'Identification'
              ) {
                if (_.findIndex(fields, { name: 'Person 3 - Identification' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c18',
                    icon: 'perm_contact_calendar',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 3 - Identification' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) === 'Family relations'
              ) {
                if (_.findIndex(fields, { name: 'Person 3 - Family relations' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c19',
                    icon: 'wc',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 3 - Family relations' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) ===
                'Employments details (current employer)'
              ) {
                if (
                  _.findIndex(fields, {
                    name: 'Person 3 - Employments details (current employer)'
                  }) === -1
                ) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c20',
                    icon: 'work',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, {
                    name: 'Person 3 - Employments details (current employer)'
                  });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) ===
                'Employments details (previous employer)'
              ) {
                if (
                  _.findIndex(fields, {
                    name: 'Person 3 - Employments details (previous employer)'
                  }) === -1
                ) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c21',
                    icon: 'work',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, {
                    name: 'Person 3 - Employments details (previous employer)'
                  });
                  fields[idx].value.push(personField);
                }
              } else if (getFieldName({ name: personField.name, index: 1 }) === 'Notes') {
                if (_.findIndex(fields, { name: 'Person 3 - Notes' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c22',
                    icon: 'subject',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 3 - Notes' });
                  fields[idx].value.push(personField);
                }
              }
            } else if (getFieldName({ name: personField.name, index: 0 }) === 'Person 4') {
              if (getFieldName({ name: personField.name, index: 1 }) === 'Personal details') {
                if (_.findIndex(fields, { name: 'Person 4 - Personal details' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c23',
                    icon: 'account_circle',
                    isOpen: true,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 4 - Personal details' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) === 'Contact details'
              ) {
                if (_.findIndex(fields, { name: 'Person 4 - Contact details' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c24',
                    icon: 'phone',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 4 - Contact details' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) === 'Identification'
              ) {
                if (_.findIndex(fields, { name: 'Person 4 - Identification' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c25',
                    icon: 'perm_contact_calendar',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 4 - Identification' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) === 'Family relations'
              ) {
                if (_.findIndex(fields, { name: 'Person 4 - Family relations' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c26',
                    icon: 'wc',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 4 - Family relations' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) ===
                'Employments details (current employer)'
              ) {
                if (
                  _.findIndex(fields, {
                    name: 'Person 4 - Employments details (current employer)'
                  }) === -1
                ) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c27',
                    icon: 'work',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, {
                    name: 'Person 4 - Employments details (current employer)'
                  });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) ===
                'Employments details (previous employer)'
              ) {
                if (
                  _.findIndex(fields, {
                    name: 'Person 4 - Employments details (previous employer)'
                  }) === -1
                ) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c28',
                    icon: 'work',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, {
                    name: 'Person 4 - Employments details (previous employer)'
                  });
                  fields[idx].value.push(personField);
                }
              } else if (getFieldName({ name: personField.name, index: 1 }) === 'Notes') {
                if (_.findIndex(fields, { name: 'Person 4 - Notes' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c29',
                    icon: 'subject',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 4 - Notes' });
                  fields[idx].value.push(personField);
                }
              }
            } else if (getFieldName({ name: personField.name, index: 0 }) === 'Person 5') {
              if (getFieldName({ name: personField.name, index: 1 }) === 'Personal details') {
                if (_.findIndex(fields, { name: 'Person 5 - Personal details' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c30',
                    icon: 'account_circle',
                    isOpen: true,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 5 - Personal details' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) === 'Contact details'
              ) {
                if (_.findIndex(fields, { name: 'Person 5 - Contact details' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c31',
                    icon: 'phone',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 5 - Contact details' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) === 'Identification'
              ) {
                if (_.findIndex(fields, { name: 'Person 5 - Identification' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c32',
                    icon: 'perm_contact_calendar',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 5 - Identification' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) === 'Family relations'
              ) {
                if (_.findIndex(fields, { name: 'Person 5 - Family relations' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c33',
                    icon: 'wc',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 5 - Family relations' });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) ===
                'Employments details (current employer)'
              ) {
                if (
                  _.findIndex(fields, {
                    name: 'Person 5 - Employments details (current employer)'
                  }) === -1
                ) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c34',
                    icon: 'work',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, {
                    name: 'Person 5 - Employments details (current employer)'
                  });
                  fields[idx].value.push(personField);
                }
              } else if (
                getFieldName({ name: personField.name, index: 1 }) ===
                'Employments details (previous employer)'
              ) {
                if (
                  _.findIndex(fields, {
                    name: 'Person 5 - Employments details (previous employer)'
                  }) === -1
                ) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c35',
                    icon: 'work',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, {
                    name: 'Person 5 - Employments details (previous employer)'
                  });
                  fields[idx].value.push(personField);
                }
              } else if (getFieldName({ name: personField.name, index: 1 }) === 'Notes') {
                if (_.findIndex(fields, { name: 'Person 5 - Notes' }) === -1) {
                  fields.push({
                    name: getFieldFullName({ name: personField.name }),
                    level: 0,
                    weight: 'c36',
                    icon: 'subject',
                    isOpen: false,
                    value: [personField]
                  });
                } else {
                  const idx = _.findIndex(fields, { name: 'Person 5 - Notes' });
                  fields[idx].value.push(personField);
                }
              }
            }
          }
        }

        if (isCompany) {
          const companyFields = IMPORT.MERGE_FIELDS.CONTACT_COMPANY || [];
          const cLen = companyFields.length;
          for (let c = 0; c < cLen; c += 1) {
            const companyField = companyFields[c];
            if (getFieldName({ name: companyField.name, index: 1 }) === 'Company details') {
              if (_.findIndex(fields, { name: 'Company - Company details' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: companyField.name }),
                  level: 0,
                  weight: 'd01',
                  icon: 'account_circle',
                  isOpen: true,
                  value: [companyField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Company - Company details' });
                fields[idx].value.push(companyField);
              }
            } else if (
              getFieldName({ name: companyField.name, index: 1 }) === 'Contact details'
            ) {
              if (_.findIndex(fields, { name: 'Company - Contact details' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: companyField.name }),
                  level: 0,
                  weight: 'd03',
                  icon: 'phone',
                  isOpen: false,
                  value: [companyField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Company - Contact details' });
                fields[idx].value.push(companyField);
              }
            } else if (getFieldName({ name: companyField.name, index: 1 }) === 'Notes') {
              if (_.findIndex(fields, { name: 'Company - Notes' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: companyField.name }),
                  level: 0,
                  weight: 'd04',
                  icon: 'subject',
                  isOpen: false,
                  value: [companyField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Company - Notes' });
                fields[idx].value.push(companyField);
              }
            }
          }
        }

        if (isNote) {
          const noteFields = IMPORT.MERGE_FIELDS.NOTE || [];
          const nLen = noteFields.length;
          for (let n = 0; n < nLen; n += 1) {
            const noteField = noteFields[n];
            if (getFieldName({ name: noteField.name, index: 1 }) === 'Basic information') {
              if (_.findIndex(fields, { name: 'Note - Basic information' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: noteField.name }),
                  level: 0,
                  weight: 'e01',
                  icon: 'insert_drive_file',
                  isOpen: true,
                  value: [noteField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Note - Basic information' });
                fields[idx].value.push(noteField);
              }
            }
          }
        }

        if (isJob) {
          const jobFields = IMPORT.MERGE_FIELDS.JOB || [];
          const jLen = jobFields.length;
          for (let t = 0; t < jLen; t += 1) {
            const jobField = jobFields[t];
            if (getFieldName({ name: jobField.name, index: 1 }) === 'Basic information') {
              if (_.findIndex(fields, { name: 'Task - Basic information' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: jobField.name }),
                  level: 0,
                  weight: 'f01',
                  icon: 'check_circle',
                  isOpen: true,
                  value: [jobField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Task - Basic information' });
                fields[idx].value.push(jobField);
              }
            }
          }
        }

        if (isAccount) {
          const accountFields = IMPORT.MERGE_FIELDS.ACCOUNT || [];
          const aLen = accountFields.length;
          for (let a = 0; a < aLen; a += 1) {
            const accountField = accountFields[a];
            if (getFieldName({ name: accountField.name, index: 1 }) === 'Basic information') {
              if (_.findIndex(fields, { name: 'Account - Basic information' }) === -1) {
                fields.push({
                  name: getFieldFullName({ name: accountField.name }),
                  level: 0,
                  weight: 'g01',
                  icon: 'check_circle',
                  isOpen: true,
                  value: [accountField]
                });
              } else {
                const idx = _.findIndex(fields, { name: 'Account - Basic information' });
                fields[idx].value.push(accountField);
              }
            }
          }
        }

        return fields;
      });
  };

  return {
    getFields,
    getFieldName,
    getFieldFullName
  };
};
